import User from '../service/api/user';

export const jumpSSO = () => {
  // console.log("jump sso");
  User.getSSOToken().then((res) => {
    // console.log(res);
    localStorage.setItem('flag', true);
    location.href = res.authorizeUrl;
  });
};

export const validateIdNumber = (rule, value, callback) => {
  if (!value) callback();
  if (/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
    callback();
  }
  callback(new Error('请输入正确的18位身份证号码'));
};

export const validatePhoneNumber = (rule, value, callback) => {
  if (/^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(value)) {
    callback();
  }
  if (value) callback(new Error('手机号码错误'));
};

export const validateEmail = (rule, value, callback) => {
  if (/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value)) {
    callback();
  }
  if (value) callback(new Error('电子邮箱错误'));
};

export const validatePassword = (rule, value, callback) => {
  if (/^[a-zA-Z]\w{5,20}$/.test(value)) {
    callback();
  }
  value && callback(new Error('长度5-20之间，字母开头，包含字母数字'));
};

export const findAreaName = (dicOptions, code, depth = 3) => {
  let resultName = [];
  let resultMergerName = '';
  try {
    const childrenTreeToLabel = (data, level) => {
      for (let j = 0; j < data.length; j++) {
        resultName.push(data[j].name);
        if (data[j].code == code) {
          resultMergerName = data[j].mergerName;
          throw new Error();
        }
        if (data[j].children) {
          childrenTreeToLabel(data[j].children, level + 1);
        }
        resultName = resultName.slice(0, level);
      }
    };
    childrenTreeToLabel(dicOptions, 0);
  } catch {
    if (resultMergerName) return resultMergerName;
    if (resultName.length < depth) return '';
    return resultName
      .filter((i) => !i.includes('直辖') && !i.includes('市辖'))
      .map((i) => i.replace(/[省|市|县|区]/g, ''))
      .slice(0, depth)
      .join(',');
  }
};
